import React from 'react';
import './RatingCheckbox.css';

interface RatingCheckboxProps {
  label: string;
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
}

const ratingLabels: { [key: number]: string } = {
  10: 'Extreme',
  9: 'Very High',
  8: 'High',
  7: 'Good',
  6: 'Above Average',
  5: 'Average',
  4: 'Below Average',
  3: 'Low',
  2: 'Very Low',
  1: 'Extreme Low',
};

const RatingCheckbox: React.FC<RatingCheckboxProps> = ({ 
  label, 
  value, 
  onChange, 
  min = 1, 
  max = 10 
}) => {
  const ratings = Array.from({ length: max - min + 1 }, (_, i) => max - i);

  return (
    <div className="rating-checkbox-group">
      <label className="rating-group-label">{label}</label>
      <div className="checkbox-container">
        {ratings.map((rating) => (
          <label key={rating} className="checkbox-label">
            <input
              type="radio"
              name={label.toLowerCase().replace(/\s+/g, '-')}
              value={rating}
              checked={value === rating}
              onChange={() => onChange(rating)}
              className="rating-checkbox"
            />
            <span className="checkbox-text">
              <span className="rating-number">{rating}</span>
              <span className="rating-label-text">{ratingLabels[rating]}</span>
            </span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default RatingCheckbox;

